


































import { defineComponent, PropType } from '@vue/composition-api'
import { getAgencies } from '~/api/Agency/agency.api'
import { remittanceBalanceController } from '~/api/Remittances/remittances.api'
import Autocomplete from '~/components/Autocomplete.vue'
import CreateDialog from '~/components/CreateDialog.vue'
import { crudEditComposition } from '~/compositions/crudEditComposition'
import { Params } from '~/utils/interfaces'
import {
  DeliveryCurrenciesEnum,
  RemittanceBalance,
} from '~/utils/interfaces/remittance.interface'
import vRules from '~/utils/vRules'
export default defineComponent({
  components: { Autocomplete, CreateDialog },
  props: {
    editedItem: { type: Object as PropType<RemittanceBalance>, default: null },
    value: { type: Boolean, default: false },
  },
  setup: (props, ctx) => {
    const composition = crudEditComposition(
      props,
      ctx,
      {
        agency: '',
        delivery_currency: DeliveryCurrenciesEnum.MLC,
      },
      remittanceBalanceController.createOrUpdateJson,
    )
    return {
      ...composition,
      getAgencies: (params?: Params) =>
        getAgencies({ ...params, not_self: true }),
      vRules,
      currencies: Object.values(DeliveryCurrenciesEnum),
    }
  },
})
